<template>
  <component
    :is="mainComponent"
    v-if="isAppLoaded"
  />
  <MainLoader
    v-else
    message="Allposit loading your repositories..."
  />
  <AppInvites />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useResponsive } from '@/plugins/responsiveUI'

import { useRepositoriesStore } from '@/store/repositories/index'
import { useUserSubscriptionsStore } from '@/store/user/subscriptions'

import { AppInvites } from '@app'

import MainDesktop from './MainDesktop.vue'
import MainMobile from './MainMobile.vue'
import MainLoader from './components/MainLoader.vue'

defineOptions({ name: 'MainLayout' })

const repositoriesStore = useRepositoriesStore()
const userSubscriptionsStore = useUserSubscriptionsStore()

const { isMobile, isTablet } = useResponsive()

const mainComponent = computed(() =>
  isMobile.value || isTablet.value ? MainMobile : MainDesktop,
)

const isAppLoaded = computed(() => repositoriesStore.initFlag || userSubscriptionsStore.isInactive)
</script>
